import React, { useEffect, useState } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import useAuth from '../../context/auth/useAuth'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { dashboardClub } from '../../actions/payments/paymentActions'

export default function Dashboard() {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const {clientauth} = useAuth()

    const {club} = useSelector(state=>state.clubs)
    const {resume} = useSelector(state=>state.payment)

    const [totalQuantity,setTotalQuantity]= useState(0)
    const [totalRawQuantity,setTotalRawQuantity]= useState(0)
    const [totalRefunded,setTotalRefunded]= useState(0)
    const [totalBenefit,setTotalBenefit]= useState(0)

    const formatNumber = (num) => {
        return new Intl.NumberFormat('es-ES', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(num)
    }

    useEffect(() => {
        if(club){
            dispatch(dashboardClub(club?._id))
        }
    },[dispatch, t, club])

    useEffect(()=>{
        if(resume){
            setTotalQuantity(parseFloat(resume.totalQuantity) || 0)
            setTotalRawQuantity(parseFloat(resume.totalRawQuantity) || 0)
            setTotalRefunded(parseFloat(resume.totalRefunded) || 0)
            setTotalBenefit(parseFloat(resume.totalBenefit) || 0)
        }
    },[resume])

    return (
        <Container className='cuerpo'>
            <div className='welcome-banner'>
                <div className='welcome-content'>
                    <span className='welcome-label'>{t('club.dashboard.welcome')}</span>
                    <h1 className='welcome-title'>{club?.name}</h1>
                    <p className='welcome-subtitle'>{t('club.dashboard.subwelcome')}</p>
                </div>
                <div className='welcome-icon'>
                    {club?.avatar
                        ? <img src={club.avatar} alt={club.name} width={64} height={64} style={{borderRadius: 16, objectFit: 'cover'}} />
                        : <i className="fas fa-building"></i>
                    }
                </div>
            </div>

            <Row className='g-4 mb-5'>
                <Col xs={6} lg={4}>
                    <div className='kpi-card'>
                        <div className='kpi-header'>
                            <div>
                                <div className='kpi-value'>{formatNumber(parseFloat(totalRawQuantity.toString().replace(',', '.')) || 0)} €</div>
                                <div className='kpi-label'>{t('club.dashboard.balance')}</div>
                            </div>
                            <div className='kpi-icon teal'>
                                <i className="fas fa-euro-sign"></i>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col xs={6} lg={4}>
                    <div className='kpi-card'>
                        <div className='kpi-header'>
                            <div>
                                <div className='kpi-value'>{formatNumber(parseFloat(totalRefunded.toString().replace(',', '.')) || 0)} €</div>
                                <div className='kpi-label'>{t('club.dashboard.refunded')}</div>
                            </div>
                            <div className='kpi-icon orange'>
                                <i className="fas fa-undo"></i>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col xs={12} lg={4}>
                    <Link to={`/${t("url.club.club")}/${t("url.club.payments")}`} className='text-decoration-none'>
                        <div className='kpi-card kpi-card-link'>
                            <div className='kpi-header'>
                                <div>
                                    <div className='kpi-label' style={{fontSize: 16, fontWeight: 600, color: 'var(--text-primary)'}}>{t('club.dashboard.payments')}</div>
                                    <div className='kpi-label'>{t('club.dashboard.viewAll') || 'Ver todos'}</div>
                                </div>
                                <div className='kpi-icon navy'>
                                    <i className="fas fa-credit-card"></i>
                                </div>
                            </div>
                        </div>
                    </Link>
                </Col>
            </Row>

            {
                club?.activitybooking && (
                    <>
                        <div className='section-title'>
                            <h2>{t('club.dashboard.activityBooking') || 'Actividades'}</h2>
                        </div>
                        <Row className='g-4 mb-4'>
                            <Col xs={12} sm={6} lg={3}>
                                <Link to={`/${t("url.club.club")}/${t("url.club.inscriptions")}`} className='text-decoration-none'>
                                    <div className='nav-card-action'>
                                        <div className='nav-card-icon teal'>
                                            <i className="fas fa-calendar-check"></i>
                                        </div>
                                        <div className='nav-card-info'>
                                            <h3>{t('club.dashboard.inscriptions')}</h3>
                                        </div>
                                        <i className="fas fa-chevron-right nav-card-arrow"></i>
                                    </div>
                                </Link>
                            </Col>
                            <Col xs={12} sm={6} lg={3}>
                                <Link to={`/${t("url.club.club")}/${t("url.club.groups")}`} className='text-decoration-none'>
                                    <div className='nav-card-action'>
                                        <div className='nav-card-icon navy'>
                                            <i className="fas fa-layer-group"></i>
                                        </div>
                                        <div className='nav-card-info'>
                                            <h3>{t('club.dashboard.groups')}</h3>
                                        </div>
                                        <i className="fas fa-chevron-right nav-card-arrow"></i>
                                    </div>
                                </Link>
                            </Col>
                            <Col xs={12} sm={6} lg={3}>
                                <Link to={`/${t("url.club.club")}/${t("url.club.activities")}`} className='text-decoration-none'>
                                    <div className='nav-card-action'>
                                        <div className='nav-card-icon green'>
                                            <i className="fas fa-running"></i>
                                        </div>
                                        <div className='nav-card-info'>
                                            <h3>{t('club.dashboard.activities')}</h3>
                                        </div>
                                        <i className="fas fa-chevron-right nav-card-arrow"></i>
                                    </div>
                                </Link>
                            </Col>
                            <Col xs={12} sm={6} lg={3}>
                                <Link to={`/${t("url.club.club")}/${t("url.club.categories")}`} className='text-decoration-none'>
                                    <div className='nav-card-action'>
                                        <div className='nav-card-icon orange'>
                                            <i className="fas fa-tags"></i>
                                        </div>
                                        <div className='nav-card-info'>
                                            <h3>{t('club.dashboard.categories')}</h3>
                                        </div>
                                        <i className="fas fa-chevron-right nav-card-arrow"></i>
                                    </div>
                                </Link>
                            </Col>
                        </Row>
                    </>
                )
            }

            {
                club?.renting && (
                    <>
                        <div className='section-title'>
                            <h2>{t('club.dashboard.renting') || 'Alquiler'}</h2>
                        </div>
                        <Row className='g-4 mb-4'>
                            <Col xs={12} sm={6} lg={3}>
                                <Link to={`/${t("url.club.club")}/${t("url.club.sites")}`} className='text-decoration-none'>
                                    <div className='nav-card-action'>
                                        <div className='nav-card-icon teal'>
                                            <i className="fas fa-map-marker-alt"></i>
                                        </div>
                                        <div className='nav-card-info'>
                                            <h3>{t('club.dashboard.sites')}</h3>
                                        </div>
                                        <i className="fas fa-chevron-right nav-card-arrow"></i>
                                    </div>
                                </Link>
                            </Col>
                            <Col xs={12} sm={6} lg={3}>
                                <Link to={`/${t("url.club.club")}/${t("url.club.courts")}`} className='text-decoration-none'>
                                    <div className='nav-card-action'>
                                        <div className='nav-card-icon navy'>
                                            <i className="fas fa-table-tennis"></i>
                                        </div>
                                        <div className='nav-card-info'>
                                            <h3>{t('club.dashboard.courts')}</h3>
                                        </div>
                                        <i className="fas fa-chevron-right nav-card-arrow"></i>
                                    </div>
                                </Link>
                            </Col>
                            <Col xs={12} sm={6} lg={3}>
                                <Link to={`/${t("url.club.club")}/${t("url.club.courtsrents")}`} className='text-decoration-none'>
                                    <div className='nav-card-action'>
                                        <div className='nav-card-icon green'>
                                            <i className="fas fa-clock"></i>
                                        </div>
                                        <div className='nav-card-info'>
                                            <h3>{t('club.dashboard.courtsrents')}</h3>
                                        </div>
                                        <i className="fas fa-chevron-right nav-card-arrow"></i>
                                    </div>
                                </Link>
                            </Col>
                        </Row>
                    </>
                )
            }

            {
                club?.ticketing && (
                    <>
                        <div className='section-title'>
                            <h2>{t('club.dashboard.ticketing') || 'Ticketing'}</h2>
                        </div>
                        <Row className='g-4 mb-4'>
                            <Col xs={12} sm={6} lg={3}>
                                <Link to={`/${t("url.club.club")}/${t("url.club.matches")}`} className='text-decoration-none'>
                                    <div className='nav-card-action'>
                                        <div className='nav-card-icon orange'>
                                            <i className="fas fa-trophy"></i>
                                        </div>
                                        <div className='nav-card-info'>
                                            <h3>{t('club.dashboard.matches')}</h3>
                                        </div>
                                        <i className="fas fa-chevron-right nav-card-arrow"></i>
                                    </div>
                                </Link>
                            </Col>
                            <Col xs={12} sm={6} lg={3}>
                                <Link to={`/${t("url.club.club")}/${t("url.club.passes")}`} className='text-decoration-none'>
                                    <div className='nav-card-action'>
                                        <div className='nav-card-icon teal'>
                                            <i className="fas fa-ticket-alt"></i>
                                        </div>
                                        <div className='nav-card-info'>
                                            <h3>{t('club.dashboard.passes')}</h3>
                                        </div>
                                        <i className="fas fa-chevron-right nav-card-arrow"></i>
                                    </div>
                                </Link>
                            </Col>
                            <Col xs={12} sm={6} lg={3}>
                                <Link to={`/${t("url.club.club")}/${t("url.club.tickets")}`} className='text-decoration-none'>
                                    <div className='nav-card-action'>
                                        <div className='nav-card-icon navy'>
                                            <i className="fas fa-ticket"></i>
                                        </div>
                                        <div className='nav-card-info'>
                                            <h3>{t('club.dashboard.tickets')}</h3>
                                        </div>
                                        <i className="fas fa-chevron-right nav-card-arrow"></i>
                                    </div>
                                </Link>
                            </Col>
                        </Row>
                    </>
                )
            }
        </Container>
    )
}
